/* eslint-disable no-nested-ternary */
import React, { useState } from "react";

import { TaskInterface } from "services/api";
import { montarPdvEmpreendimento } from "utils/montarPdvEmpreendimento";
import * as Styles from "./styles";
import * as SVG from "../../../../../../../assets/iconsSVG";

interface Props {
  statusTarefa: 1 | 2 | 3;
  data: TaskInterface;
}

const ConcludeTaskCard: React.FC<Props> = (props) => {
  const [mostrarTudo, setMostrarTudo] = useState(false);
  const limiteCaracteres = 250;
  const generateStatusColor = () => {
    switch (props?.data?.codigoStatusTarefa) {
      case 3:
        return { bgColor: "#4CAF50", textColor: "#ffffff", text: "Concluída" };
      case 1:
        return { bgColor: "#F43636", textColor: "#ffffff", text: "Atrasada" };
      case 2:
        return { bgColor: "#D5D5D5", textColor: "#333333", text: "Em Aberto" };
      default:
        return { bgColor: "#D5D5D5", textColor: "#333333", text: "Em Aberto" };
    }
  };
  return (
    <Styles.Container>
      <Styles.Row>
        <SVG.CalendarTaskIcon />
        <Styles.Text>
          {props.data?.dataHoraProgramadaRealizacaoTarefa || "--"}
        </Styles.Text>
      </Styles.Row>
      {props?.data?.tipoTarefa === "Agendamento de Visita" ||
      props?.data?.tipoTarefa === "Mobi" ? (
        <>
          <Styles.SpaceY space={8} />
          <Styles.Row style={{ alignItems: "center" }}>
            <SVG.ProductPredio2 />
            <Styles.Text>
              {montarPdvEmpreendimento(
                props?.data?.nomePdv,
                props?.data?.empreendimento ||
                  props.data?.empreendimentoRegionalSul
              )}
            </Styles.Text>
          </Styles.Row>
        </>
      ) : null}
      <Styles.SpaceY space={8} />
      <Styles.Row>
        <Styles.ColumnFlex>
          <Styles.Title>{props?.data?.titulo || "--"}</Styles.Title>
          <Styles.RowGap>
            <Styles.Row>
              <SVG.UserTaskIcon />
              <Styles.Text>{props?.data?.nomeLead || "--"}</Styles.Text>
            </Styles.Row>
          </Styles.RowGap>
        </Styles.ColumnFlex>
        <Styles.Row>
          <Styles.Badge color={generateStatusColor().bgColor}>
            <Styles.BadgeText color={generateStatusColor().textColor}>
              {generateStatusColor().text}
            </Styles.BadgeText>
          </Styles.Badge>
        </Styles.Row>
      </Styles.Row>
      {props?.data?.descricao || props.data.observacao ? (
        <Styles.MessageWrapper>
          <Styles.Column>
            <Styles.RowGap>
              <Styles.Column>
                <Styles.MessageTitle>Resultado</Styles.MessageTitle>
                <Styles.SpaceY space={4} />
                <Styles.Text>{props.data.tipoResultadoTarefa}</Styles.Text>
              </Styles.Column>
              <Styles.Column>
                <Styles.MessageTitle>Data de conclusão</Styles.MessageTitle>
                <Styles.SpaceY space={4} />
                <Styles.Text>{props.data.dataHoraConclusaoTarefa}</Styles.Text>
              </Styles.Column>
            </Styles.RowGap>
            <Styles.SpaceY space={16} />
            <Styles.Row>
              <SVG.DescriptionIcon />
              <Styles.MessageTitle>
                {props.data.codigoStatusTarefa === 3
                  ? "Observação sobre o resultado"
                  : "Descrição"}
              </Styles.MessageTitle>
            </Styles.Row>
            <Styles.SpaceY space={4} />
            <Styles.TextDesc mostrarTudo={mostrarTudo}>
              {props?.data?.observacao?.length > limiteCaracteres &&
              !mostrarTudo
                ? `${props?.data?.observacao?.slice(0, limiteCaracteres)}...`
                : props?.data?.observacao}
            </Styles.TextDesc>
            {props?.data?.observacao?.length > limiteCaracteres ? (
              <Styles.ButtonRightWrapper>
                <Styles.BotaoMostrarMais
                  onClick={() => setMostrarTudo(!mostrarTudo)}
                >
                  <p>{mostrarTudo ? "Mostrar menos" : "Mostrar mais"}</p>
                </Styles.BotaoMostrarMais>
              </Styles.ButtonRightWrapper>
            ) : null}
          </Styles.Column>
          {props?.data?.anexo?.urlAnexo ? (
            <>
              <Styles.SpaceY space={16} />
              <Styles.MessageTitle>Anexos</Styles.MessageTitle>
              <Styles.SpaceY space={4} />
              <Styles.Text style={{ color: "#2D5BFF" }}>
                <a href={props?.data?.anexo?.urlAnexo}>Baixar arquivo</a>
              </Styles.Text>
            </>
          ) : (
            <></>
          )}
        </Styles.MessageWrapper>
      ) : null}
    </Styles.Container>
  );
};

export default ConcludeTaskCard;
